<template>
  <form @submit.prevent="handleSubmit" class="d-flex align-items-end">
    <div class="mb-3 me-3">
      <label for="date" class="form-label">Date</label>
      <input type="date" class="form-control" id="date" v-model="formattedDate" required>
    </div>
    <div class="mb-3 me-3">
      <label for="evaluation_type" class="form-label">Evaluation Type</label>
      <select class="form-control" id="evaluation_type" v-model="localDeadline.evaluation_type" required>
        <option v-for="type in evaluationTypes" :key="type" :value="type">{{ type }}</option>
      </select>
    </div>
    <div class="mb-3">
      <button type="submit" class="btn btn-primary">{{ buttonText }}</button>
      <button v-if="localDeadline.id" type="button" class="btn btn-danger ms-2" @click="deleteDeadline(localDeadline.id)">Delete Deadline</button>
    </div>
  </form>

  <StemErrorModal ref="stemErrorModal"/>
</template>

<script>
import Deadline from '@/models/deadline';
import DeadlineController from '@/controllers/DeadlineController';
import StemErrorModal from './StemErrorModal.vue';

export default {
  components: {
    StemErrorModal,
  },
  props: {
    deadline: {
      type: Object,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localDeadline: { ...this.deadline },
      evaluationTypes: Deadline.evaluationTypes,
    };
  },
  computed: {
    formattedDate: {
      get() {
        return Deadline.formatDateForInput(this.localDeadline.date);
      },
      set(newDate) {
        this.localDeadline.date = newDate;
      },
    },
  },
  watch: {
    deadline: {
      handler(newDeadline) {
        this.localDeadline = { ...newDeadline };
      },
      deep: true,
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('submitForm', this.localDeadline);
    },
    async deleteDeadline(deadlineId) {
      if (confirm('Do you want to delete this deadline? This will permanently delete deadline and all related evaluations, their subevaluations.')) {
        try {
          await DeadlineController.deleteDeadline(deadlineId);
          // Dispatch alert action
          this.$store.dispatch('triggerAlert', {
            title: 'Success',
            message: 'Deadline was deleted successfully',
            type: 'success',
          });
          this.$emit('deleteDeadline', deadlineId);
        } catch (error) {
          this.$refs.stemErrorModal.show('Error', error.message);
        }
      }
    },
  },
};
</script>